import React, { ComponentProps } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FaSave } from 'react-icons/fa';

type Props = React.PropsWithoutRef<ComponentProps<typeof Button>> & {
  readonly loading?: boolean;
};

const ButtonSubmit = ({ loading = false, ...props }: Props) => {
  const { t, i18n } = useTranslation();
  return (
    <Button
      {...props}
      style={{ width: '160px' }}
      variant="success"
      type="submit"
    >
      {loading ? (
        <Spinner animation="border" size="sm" className="mb-1" />
      ) : (
        <FaSave className="mb-1" />
      )}
      &nbsp;
      {i18n.language === 'en'
        ? t('Save')
        : i18n.language === 'ro'
        ? t('Salveaza')
        : t('Αποθήκευση')}
    </Button>
  );
};

export default React.memo(ButtonSubmit);

